/**
 * Pure helpers for the Temples & Sacred Places listing.
 * A "place" is { id, type: 'temple'|'ghat', name, description, timings, popularity, featured, ... }.
 */

const toMinutes = (s) => {
  const m = String(s).match(/(\d{1,2})(?::(\d{2}))?\s*(AM|PM)/i);
  if (!m) return null;
  let h = Number(m[1]) % 12;
  if (/pm/i.test(m[3])) h += 12;
  return h * 60 + (Number(m[2]) || 0);
};

/** Which parts of the day a timings string covers: subset of ['morning','afternoon','evening']. */
export function timingBucket(timings = '') {
  if (!timings || /24\s*hours|open daily|all day/i.test(timings)) return ['morning', 'afternoon', 'evening'];
  const ranges = timings
    .split(',')
    .map((r) => r.split(/\s*[-–]\s*/).map(toMinutes))
    .filter((r) => r.length === 2 && r[0] != null && r[1] != null);
  if (!ranges.length) return ['morning', 'afternoon', 'evening'];
  const covers = (from, to) => ranges.some(([a, b]) => a < to && b > from);
  const out = [];
  if (covers(5 * 60, 12 * 60)) out.push('morning');
  if (covers(12 * 60, 16 * 60)) out.push('afternoon');
  if (covers(16 * 60, 23 * 60)) out.push('evening');
  return out;
}

export function applyPlaceFilters(places, { tab = 'all', q = '', category = 'all', timing = 'any', featuredOnly = false } = {}) {
  const needle = q.trim().toLowerCase();
  return places.filter((p) => {
    if (tab === 'temples' && p.type !== 'temple') return false;
    if (tab === 'ghats' && p.type !== 'ghat') return false;
    if (category !== 'all' && p.type !== category) return false;
    if (featuredOnly && !p.featured) return false;
    if (timing !== 'any' && !timingBucket(p.timings).includes(timing)) return false;
    if (needle && !`${p.name} ${p.hindi || ''} ${p.description || ''}`.toLowerCase().includes(needle)) return false;
    return true;
  });
}

export function sortPlaces(places, by = 'popularity') {
  const copy = [...places];
  if (by === 'name') return copy.sort((a, b) => a.name.localeCompare(b.name));
  return copy.sort((a, b) => (b.popularity || 0) - (a.popularity || 0));
}
